/* Vinyl Legend: Sleeve Wall homepage behaviour */
(() => {
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const hl = (txt, q) => {
    let out = esc(txt);
    q.split(/\s+/).filter(w => w.length > 1).forEach(w => {
      out = out.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return out;
  };
  const money = p => {
    if (p == null || p === '') return '';
    const s = String(p);
    const n = s.includes('.') ? parseFloat(s) : parseFloat(s) / 100;
    return isNaN(n) ? '' : 'R ' + Math.round(n).toLocaleString('en-US');
  };

  function initSearch(form) {
    if (form.dataset.vlReady) return;
    form.dataset.vlReady = '1';
    const input = form.querySelector('input[name="q"]');
    const box = form.querySelector('.vl-sugg');
    if (!input || !box) return;
    const artists = (form.dataset.artists || '').split(',').map(s => s.trim()).filter(Boolean);
    const customUrl = form.dataset.customOrders || '';
    const searchUrl = form.getAttribute('action') || '/search';
    const suggestUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    const idBase = form.id || 'vl-search';
    let active = -1, timer = null, ctrl = null;

    const open = html => { box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1; };
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); };
    const chips = () => {
      if (!artists.length) return close();
      open(`<div class="vl-sg-head">${esc(form.dataset.chipsLabel || 'Try an artist')}</div><div class="vl-chips">${artists.map(a => `<button type="button" class="vl-chip" data-a="${esc(a)}">${esc(a)}</button>`).join('')}</div>`);
    };

    async function run() {
      const q = input.value.trim();
      if (!q) return chips();
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const all = `${searchUrl}?q=${encodeURIComponent(q)}&type=product`;
      try {
        const url = `${suggestUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=hide`;
        const res = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
        const data = await res.json();
        const items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          return open(`<p class="vl-sg-empty">Nothing in stock matches “${esc(q)}” right now. <a href="${all}">Search the whole shop</a>${customUrl ? ` or <a href="${esc(customUrl)}">ask us to order it in</a>` : ''}.</p>`);
        }
        open(items.map((p, i) => {
          const parts = String(p.title || '').split(/\s+[–-]\s+/);
          const artist = parts.length > 1 ? parts.shift() : '';
          const title = parts.join(' – ');
          const sealed = (p.tags || []).indexOf('New Vinyl Records') > -1;
          const img = p.image ? p.image + (String(p.image).indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return `<a class="vl-sg-row" id="${idBase}-o${i}" role="option" aria-selected="false" href="${esc(p.url)}">` +
            (img ? `<img src="${esc(img)}" alt="" width="56" height="56" loading="lazy">` : '<span></span>') +
            `<span><b>${hl(artist || title, q)}</b><span class="t">${artist ? hl(title, q) : ''}</span>${sealed ? '<small>New, sealed</small>' : ''}</span><em>${money(p.price)}</em></a>`;
        }).join('') + `<a class="vl-sg-all" href="${all}"><span>See all results for “${esc(q)}”</span><span aria-hidden="true">→</span></a>`);
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    }

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 160); });
    input.addEventListener('focus', () => (input.value.trim() ? run() : chips()));
    input.addEventListener('blur', () => setTimeout(close, 150));
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') { close(); return; }
      const rows = Array.from(box.querySelectorAll('.vl-sg-row'));
      if (box.hidden || !rows.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
        rows.forEach((r, i) => r.setAttribute('aria-selected', i === active ? 'true' : 'false'));
        input.setAttribute('aria-activedescendant', rows[active].id);
        rows[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = rows[active].href;
      }
    });
    box.addEventListener('mousedown', e => e.preventDefault());
    box.addEventListener('click', e => {
      const chip = e.target.closest('.vl-chip');
      if (chip) { input.value = chip.dataset.a; run(); input.focus(); }
    });
  }

  function initStrip(sec) {
    if (sec.dataset.vlReady) return;
    sec.dataset.vlReady = '1';
    const strip = sec.querySelector('.vl-strip');
    if (!strip) return;
    const step = () => { const c = strip.querySelector('.vl-card'); return c ? c.getBoundingClientRect().width * 2 : 600; };
    const prev = sec.querySelector('[data-vl-prev]');
    const next = sec.querySelector('[data-vl-next]');
    if (prev) prev.addEventListener('click', () => strip.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => strip.scrollBy({ left: step(), behavior: 'smooth' }));
  }

  function initDecades(sec) {
    if (sec.dataset.vlReady) return;
    sec.dataset.vlReady = '1';
    const tabs = Array.from(sec.querySelectorAll('.vl-tab'));
    const big = sec.querySelector('.vl-big');
    const note = sec.querySelector('.vl-note');
    const panels = sec.querySelector('.vl-panels');
    if (!tabs.length) return;
    let current = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    const reset = () => { if (big) big.textContent = current.dataset.long; if (note) note.textContent = current.dataset.note; };
    const show = t => {
      current = t;
      tabs.forEach(b => {
        const on = b === t;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        const p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      reset();
    };
    tabs.forEach(t => t.addEventListener('click', () => show(t)));
    const list = sec.querySelector('.vl-tabs');
    if (list) list.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const i = tabs.indexOf(current);
      const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      show(n); n.focus();
    });
    const over = e => {
      const a = e.target.closest('.vl-sl[data-year]');
      if (!a || !a.dataset.year) return;
      if (big) big.textContent = a.dataset.year;
      if (note) note.innerHTML = `<b>${esc(a.dataset.artist)}</b> · ${esc(a.dataset.title)}<br>Pressed in ${a.dataset.country ? esc(a.dataset.country) + ', ' : ''}${esc(a.dataset.year)}`;
    };
    if (panels) {
      panels.addEventListener('mouseover', over);
      panels.addEventListener('focusin', over);
      panels.addEventListener('mouseleave', reset);
    }
    show(current);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-vl-search]').forEach(initSearch);
    root.querySelectorAll('[data-vl-strip]').forEach(initStrip);
    root.querySelectorAll('[data-vl-decades]').forEach(initDecades);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
